import PropTypes from 'prop-types';

import StockTransferCommandBar from './StockTransferCommandBar';
import StockTransferDetailSection from './StockTransferDetailSection';
import StockTransferMainInfoCard from './StockTransferMainInfoCard';

const StockTransferBlock = ({
  detail,
  defaultOpen = true,
  onRefetch,
  showActions = false,
  splitFullWidthDetail = false,
}) => {
  const commandBar = showActions ? (
    <StockTransferCommandBar
      key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
      detail={detail}
      onRefetch={onRefetch}
    />
  ) : null;

  const mainInfoCard = (
    <StockTransferMainInfoCard
      detail={detail}
      embedded
      actions={commandBar}
    />
  );

  if (splitFullWidthDetail) {
    return (
      <div className="space-y-4">
        <div className="mx-auto w-full max-w-4xl">
          <div className="receipt-card-elevate">
            <div className="receipt-card-surface">
              {mainInfoCard}
            </div>
          </div>
        </div>
        <div className="w-full">
          <StockTransferDetailSection
            detail={detail}
            embedded={false}
            defaultOpen={defaultOpen}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface">
        {mainInfoCard}
        <StockTransferDetailSection detail={detail} embedded defaultOpen={defaultOpen} />
      </div>
    </div>
  );
};

StockTransferBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    transferNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  defaultOpen: PropTypes.bool,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
  splitFullWidthDetail: PropTypes.bool,
};

export default StockTransferBlock;
